module.exports = __webpack_public_path__ + "img/22.f1940a44.jpg";